import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient } from '@tanstack/react-query'
import App from './App'
import { AppProviders } from './AppProviders'
// Self-host bootstrap-icons (font + CSS bundled by Vite, same-origin, hashed)
// so production never shows tofu rectangles while waiting on a CDN font.
import 'bootstrap-icons/font/bootstrap-icons.css'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppProviders queryClient={queryClient}>
      <App />
    </AppProviders>
  </StrictMode>,
)
